var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"px-4 col-sm-12 col-md-8 col-lg-12 col-xl-12 offset-md-2 offset-lg-0 offset-xl-0 col-12",class:_vm.notifications.length > 0 ? 'mt-3' : ''},_vm._l((_vm.notifications),function(notification){return _c('notification-bar',{key:notification.id,attrs:{"notification":notification}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }